import {
  DISTRIBUTION_SETUP_REQUEST,
  DISTRIBUTION_SETUP_SUCCESS,
  DISTRIBUTION_SETUP_FAIL,
  DISTRIBUTION_MY_RECORDS_REQUEST,
  DISTRIBUTION_MY_RECORDS_SUCCESS,
  DISTRIBUTION_MY_RECORDS_FAIL,
  DISTRIBUTION_SUBMIT_REQUEST,
  DISTRIBUTION_SUBMIT_SUCCESS,
  DISTRIBUTION_SUBMIT_FAIL,
  DISTRIBUTION_SUBMIT_RESET,
  DISTRIBUTION_BULK_UPDATE_REQUEST,
  DISTRIBUTION_BULK_UPDATE_SUCCESS,
  DISTRIBUTION_BULK_UPDATE_FAIL,
  DISTRIBUTION_BULK_UPDATE_RESET,
} from '../constants/distributionConstants';

export const distributionSetupReducer = (state = { sections: [] }, action) => {
  switch (action.type) {
    case DISTRIBUTION_SETUP_REQUEST:
      return { loading: true, sections: [] };
    case DISTRIBUTION_SETUP_SUCCESS:
      return { loading: false, sections: action.payload };
    case DISTRIBUTION_SETUP_FAIL:
      return { loading: false, error: action.payload, sections: [] };
    default:
      return state;
  }
};

export const distributionMyRecordsReducer = (state = { records: [] }, action) => {
  switch (action.type) {
    case DISTRIBUTION_MY_RECORDS_REQUEST:
      return { loading: true, records: [] };
    case DISTRIBUTION_MY_RECORDS_SUCCESS:
      return { loading: false, records: action.payload };
    case DISTRIBUTION_MY_RECORDS_FAIL:
      return { loading: false, error: action.payload, records: [] };
    default:
      return state;
  }
};

export const distributionSubmitReducer = (state = {}, action) => {
  switch (action.type) {
    case DISTRIBUTION_SUBMIT_REQUEST:
      return { loading: true };
    case DISTRIBUTION_SUBMIT_SUCCESS:
      return { loading: false, success: true, records: action.payload };
    case DISTRIBUTION_SUBMIT_FAIL:
      return { loading: false, error: action.payload };
    case DISTRIBUTION_SUBMIT_RESET:
      return {};
    default:
      return state;
  }
};

export const distributionBulkUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case DISTRIBUTION_BULK_UPDATE_REQUEST:
      return { loading: true };
    case DISTRIBUTION_BULK_UPDATE_SUCCESS:
      return { loading: false, success: true, records: action.payload };
    case DISTRIBUTION_BULK_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case DISTRIBUTION_BULK_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};
